
<v-hover v-slot="{ hover }" open-delay="200" >
    <div class="app-side-buttons">
        <v-scale-transition>
            <div v-show="hover || permanent">
                <c-menu-button
                    label      = "inc.overview.menu.export"
                    icon       = "mdi-download"
                    icon-color = "primary--text"
                    @click     = "onDownload"
                />

                <c-menu-button
                    label      = "inc.overview.menu.refresh"
                    icon       = "mdi-refresh"
                    icon-color = "primary--text"
                    @click     = "onRefresh"
                />
            </div>
       </v-scale-transition>
    </div>
</v-hover>
